<div class="status-badge btn justify-content-center" [style.backgroundColor]="bg" [style.color]="color"
    [ngbTooltip]="label === 'Purchased' ? tooltipContent : null" [tooltipClass]="'custom-tooltip'" placement="right"
    container="body"><span class="statusLabel">{{ params.value }}</span></div>